import React from 'react'
import Structure from '../components/layout/Structure'
import { GameForm } from '../components/Portfolio/AddForm'

const AddGames = () => {
  return (
    <Structure>
      <GameForm/>
    </Structure>
  )
}

export default AddGames